import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _DRIVER_APPLICATION_URL = "driver-application";

export async function getDriverApplicationList(params) {
    const response = await ApiBase.get(`${_DRIVER_APPLICATION_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getDriverApplicationDetail(id) {
    const response = await ApiBase.get(`${_DRIVER_APPLICATION_URL}/${id}`);

    return response;
}

export async function updateDriverApplication(params) {
    const response = await ApiBase.post(`${_DRIVER_APPLICATION_URL}`, params, { headers: { ['Content-type']: "multipart/form-data" } });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_DRIVER_APPLICATION"))

    return response;
}